import type { BasePageConfig } from '@/pageConfig/BasePageConfig';
import ogImage from '@/static/assets/home/og-de.png';

export const config: BasePageConfig = {
  seo: {
    title: 'Lemonade Contents & Personal Liability Insurance | Protect The Stuff You Love',
    metaTitle: 'Lemonade Contents & Personal Liability Insurance | Protect The Stuff You Love',
    description:
      'Lemonade offers contents and personal liability insurance powered by tech and driven by social good. ❤ We promise zero paperwork and instant everything by replacing brokers and bureaucracy with bots and machine learning. Get a Lemonade insurance policy in seconds, starting at 2 €/month.',
    ogImage: ogImage.src,
  },
  layout: {
    headerActions: {
      dropdown: {
        logout: 'Log out',
        myAccount: 'My Account',
        settings: 'Settings',
      },
      CTAs: {
        backToYourQuote: {
          long: {
            singular: 'Back to your quote',
            plural: 'Back to your quotes',
          },
          short: {
            singular: 'Quote',
            plural: 'Quotes',
          },
        },
        checkOurPrices: {
          long: {
            singular: 'Check our prices',
            plural: 'Check our prices',
          },
          short: {
            singular: 'Check our price',
            plural: 'Check our prices',
          },
        },
      },
    },
  },
};
